import { AxiosError } from "axios";

export const getErrorMessage = (error) => {
  const { response, status } = error;
  const errorMessage = response?.data?.error;
  if (status === 400) {
    return errorMessage;
  } else if (error.request) {
    return "No response from server";
  } else {
    return error.message;
  }
};
